import AccountIcon from '../../../assets/bottom-navigation-bar/account.svg';
import BingoIcon from '../../../assets/bottom-navigation-bar/bingo.svg';
import BingoActiveIcon from '../../../assets/bottom-navigation-bar/bingo_active.svg';
import LobbyIcon from '../../../assets/bottom-navigation-bar/lobby.svg';
import LobbyActiveIcon from '../../../assets/bottom-navigation-bar/lobby_active.svg';
import LoungeIcon from '../../../assets/bottom-navigation-bar/lounge.svg';
import RedeemIcon from '../../../assets/bottom-navigation-bar/redeem.svg';
import StoreIcon from '../../../assets/bottom-navigation-bar/store.svg';
import type { CoinType } from '../../../stores/cointype/CoinTypeStore';

import { AccountActiveIcon } from './AccountActiveIcon';
import { getFooterColors } from './getFooterColors';
import { LoungeActiveIcon } from './LoungeActiveIcon';
import { RedeemActiveIcon } from './RedeemActiveIcon';
import { StoreActiveIcon } from './StoreActiveIcon';

export function NavigationTabIcon({
  route,
  coinType,
  isFocused,
  className,
}: {
  route: string | null;
  coinType: CoinType;
  isFocused: boolean;
  className?: string;
}) {
  const { mainColor, secondaryColor } = getFooterColors(coinType);

  switch (route) {
    case 'home':
      return <img alt={'LobbyIcon'} className={className} src={isFocused ? LobbyActiveIcon : LobbyIcon} />;
    case 'account':
      return isFocused ? (
        <AccountActiveIcon className={className} mainColor={mainColor} secondaryColor={secondaryColor} />
      ) : (
        <img alt={'AccountIcon'} className={className} src={AccountIcon} />
      );
    case 'redeem':
      return isFocused ? (
        <RedeemActiveIcon className={className} mainColor={mainColor} secondaryColor={secondaryColor} />
      ) : (
        <img alt={'RedeemIcon'} className={className} src={RedeemIcon} />
      );
    case 'rewards':
      return isFocused ? (
        <LoungeActiveIcon className={className} mainColor={mainColor} secondaryColor={secondaryColor} />
      ) : (
        <img alt={'LoungeIcon'} className={className} src={LoungeIcon} />
      );
    case 'store':
      return isFocused ? (
        <StoreActiveIcon className={className} mainColor={mainColor} secondaryColor={secondaryColor} />
      ) : (
        <img alt={'StoreIcon'} className={className} src={StoreIcon} />
      );
    case 'bingo':
      return <img alt={'BingoIcon'} className={className} src={isFocused ? BingoActiveIcon : BingoIcon} />;
    default:
      return null;
  }
}
